import React from "react";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";

const KanbanCardQuestion = (props) => {

    return (
        <>
            <Stack style={{ marginBottom: '10px' }}>
                <>
                    <div style={{ fontSize: '14px', fontWeight: '800' }}>
                        {props.segment.question}
                    </div>
                    {props.segment.answers.map((answer, index) => {
                        if (answer.selected) {
                            return (
                                <div id={index} key={index} style={{ fontSize: '12px', fontWeight: '400' }}>
                                    {answer.answer}
                                </div>)
                        }
                    })}
                </>
            </Stack>
        </>
    );
}

KanbanCardQuestion.propTypes = {
    segment: PropTypes.object
};

export default KanbanCardQuestion;